declare global {
  interface Window {
    __uspapi?: (
      command: string,
      version: number,
      callback: (uspData: { uspString?: string }, success: boolean) => void,
    ) => void;
  }
}

const getUsPrivacyString = (timeoutMs = 2000): Promise<string> =>
  new Promise((resolve) => {
    if (typeof window === 'undefined' || typeof window.__uspapi !== 'function') {
      resolve('');
      return;
    }
    const timer = setTimeout(() => resolve(''), timeoutMs);
    try {
      window.__uspapi('getUSPData', 1, (uspData, success) => {
        clearTimeout(timer);
        resolve(success && uspData?.uspString ? uspData.uspString : '');
      });
    } catch {
      clearTimeout(timer);
      resolve('');
    }
  });

export default getUsPrivacyString;
